import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';

const Assignment: React.FC = () => {
    return (
        <div className="space-y-4 bg-gray-200 rounded-xl p-4">
            <h3 className="text-lg font-semibold text-maxi-text-dark">
                Asignación
            </h3>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <p className="text-maxi-text font-medium mb-2 text-sm">Agente</p>
                    <Select defaultValue="seguimiento">
                        <SelectTrigger className="h-8 text-xs">
                            <SelectValue placeholder="Seguimiento" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="seguimiento">Seguimiento</SelectItem>
                            <SelectItem value="oscar">Oscar Ramos</SelectItem>
                            <SelectItem value="maria">María González</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
                <div>
                    <p className="text-maxi-text font-medium mb-2 text-sm">Usuario</p>
                    <Select defaultValue="seguimiento">
                        <SelectTrigger className="h-8 text-xs">
                            <SelectValue placeholder="Seguimiento" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="seguimiento">Seguimiento</SelectItem>
                            <SelectItem value="usuario1">Usuario 1</SelectItem>
                            <SelectItem value="usuario2">Usuario 2</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
            </div>
        </div>
    );
};

export default Assignment;